import { useCallback, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useRate(pollMs = 30000) {
    const [data, setData] = useState({
        rate: null,
        updatedAt: null,
        live: false,
        loading: true,
        error: false,
        change: null,
    });
    const [, setTick] = useState(0);

    const load = useCallback(async () => {
        try {
            const res = await fetch(`${API}/rate`);
            if (!res.ok) throw new Error("rate fetch failed");
            const json = await res.json();
            setData((prev) => {
                let change = null;
                if (prev.rate !== null && json.rate !== prev.rate) {
                    change = json.rate > prev.rate ? "up" : "down";
                }
                return {
                    rate: json.rate,
                    updatedAt: json.updated_at,
                    live: !json.stale,
                    loading: false,
                    error: false,
                    change,
                };
            });
        } catch {
            setData((prev) => ({
                ...prev,
                live: false,
                loading: false,
                error: prev.rate === null,
            }));
        }
    }, []);

    useEffect(() => {
        load();
        const poll = setInterval(load, pollMs);
        const ticker = setInterval(() => setTick((t) => t + 1), 5000);
        return () => {
            clearInterval(poll);
            clearInterval(ticker);
        };
    }, [load, pollMs]);

    useEffect(() => {
        if (!data.change) return undefined;
        const timeout = setTimeout(
            () => setData((prev) => ({ ...prev, change: null })),
            4000,
        );
        return () => clearTimeout(timeout);
    }, [data.change, data.updatedAt]);

    return data;
}

export function timeAgo(iso) {
    if (!iso) return "";
    const seconds = Math.max(
        0,
        Math.floor((Date.now() - new Date(iso).getTime()) / 1000),
    );
    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds}s ago`;
    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes}m ago`;
    return `${Math.floor(minutes / 60)}h ago`;
}
